import { action, observable, makeObservable } from 'mobx';
import { injectable, inject } from '@servicetitan/react-ioc';
import { CaptchaApi } from '../api/captcha.api';

@injectable()
export class CaptchaStore {
    private captchaApi!: CaptchaApi;
    constructor(@inject(CaptchaApi) captchaApi: CaptchaApi) {
        makeObservable(this);

        this.captchaApi = captchaApi;
    }

    isCaptchaLoaded = false;
    isCaptchaLoading = false;
    siteKey?: string;

    @observable
    isCaptchaVerified = false;

    init = async () => {
        if (!this.siteKey) {
            const { data } = await this.captchaApi.getReCaptchaSiteKey();
            this.siteKey = data || undefined;
        }
    };

    @action
    triggerSuccessfulVerification = () => (this.isCaptchaVerified = true);

    toggleLoadingState = () => (this.isCaptchaLoading = !this.isCaptchaLoading);

    hasLoaded = () => (this.isCaptchaLoaded = true);

    @action
    resetVerificationStatus = () => (this.isCaptchaVerified = false);
}
